export default __webpack_public_path__ + "static/media/tablet.3248e047.svg";